import { render } from "./receivePayments.vue?vue&type=template&id=1e4dcbaa&scoped=true"
import script from "./receivePayments.vue?vue&type=script&lang=js"
export * from "./receivePayments.vue?vue&type=script&lang=js"

import "./receivePayments.vue?vue&type=style&index=0&id=1e4dcbaa&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4dcbaa"]])

export default __exports__